import { motion } from 'framer-motion';

const WhatIsConnect = () => {
  return (
    <section className="py-20 md:py-28" data-testid="what-is-connect-section">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="text-sm uppercase tracking-[0.2em] text-[#7A7A7A] mb-6">
            What is Connect?
          </h2>
          <p className="text-2xl sm:text-3xl md:text-4xl text-[#1A1A1A] leading-relaxed font-light">
            Connect is a wearable ecosystem designed to help families monitor wellness, stay connected with loved ones, and receive meaningful safety alerts in everyday life.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default WhatIsConnect;
